let toggleSectionToggled = false;
let toggleSection;

window.addEventListener("DOMContentLoaded", () => {
    toggleSection = document.querySelector("#toggle-section");
    document.querySelector("main").classList.remove("hide-contents");
});

window.addEventListener("scroll", () => {
    let toggleTop = toggleSection.getBoundingClientRect().top;

    if(window.innerWidth <= 768) {
        if (toggleTop <= 2*(window.innerHeight/3) + 50 && toggleTop >= 2*(window.innerHeight/3) - 50) {
            handleToggling(true);
        } else if (toggleSectionToggled && toggleTop >= window.innerHeight) {
            handleToggling(false);
        }
    } else {
        if (toggleTop <= (window.innerHeight/15) + 50 && toggleTop >= (window.innerHeight/15) - 50) {
            handleToggling(true);
        } else if (toggleSectionToggled && toggleTop >= window.innerHeight) {
            handleToggling(false);
        }
    }
});

function handleToggling(toggleState) {
    if(toggleState) {
        toggleSection.querySelector('[name="display-toggle"]').setAttribute("checked", true);
        toggleSection.setAttribute("toggled", "true");
        toggleSectionToggled = true;
    } else {
        toggleSection.querySelector('[name="display-toggle"]').removeAttribute("checked");
        toggleSection.removeAttribute("toggled");
        toggleSectionToggled = false;
    }
}